/* eslint-disable */



function expand(elt, btn, settings) {
  elt.removeClass(settings.className);
  elt.css({'max-height': (settings.eltHeight*2) + 'px'});
  btn.text(elt.attr('data-close-label'));
}

function collapse(elt, btn, settings, firstLoad) {
  elt.addClass(settings.className);
  elt.css({'max-height': settings.maxHeight + 'px'});
  btn.text(elt.attr('data-open-label'));
  if (firstLoad) return;
  if (window.scrollY < elt.offset().top) return;
  window.setTimeout(function() {
    $('html, body').stop().animate({ scrollTop : elt.offset().top - 60});
  }, settings.timing);
}

function constructToggle(elt, settings) {
  var elt = $(elt);
  if (elt.outerHeight() <= settings.maxHeight){
    return false;
  }
  
  var toggle = $('<div class="long-text-ctl">'+
                     '<a class="bt">' + elt.attr('data-open-label') + '</a>'+
                 '</div>').insertAfter(elt);
  var btn = toggle.find('.bt');
  settings.eltHeight = elt.outerHeight();
  settings.timing = window.getComputedStyle(elt[0])['transitionDuration'] || 0;
  settings.timing = parseFloat(settings.timing)*1000;

  btn.click(function() {
    if (elt.hasClass(settings.className)) {
      expand(elt, btn, settings);
    } else {
      collapse(elt, btn, settings);
    }
  });

  if (elt.outerHeight() > settings.maxHeight) collapse(elt, btn, settings, true);
}

function initialise(settings) {
  var elts = $(settings.selector);
  $.each(elts, function(i, elt) { constructToggle(elt, settings); });
}

module.exports = {
  initialise: initialise
};
